module.exports = "<div class=\"animated fadeIn body\">\r\n    <div #container></div>\r\n</div>\r\n\r\n<info-box [text]=\"''\" [visible]=\"infoBoxVisible\"></info-box>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/item-body-panel.component.html
// module id = AL60
// module chunks = 1